import * as Graph from '../graph';
import * as Types from '../model/types';

export const opIf = Graph.makeOp({
  name: 'if',
  hidden: true,
  argTypes: {
    condition: Types.maybe('boolean'),
    then: 'any',
    else: 'any',
  },
  kind: 'basic',
  description:
    'If the condition is true, returns the then value, otherwise returns the else value',
  argDescriptions: {
    condition: 'Condition to evaluate',
    then: 'Value to return if condition is true',
    else: 'Value to return if condition is false',
  },
  returnValueDescription:
    'If the condition is true, returns the then value, otherwise returns the else value',
  returnType: inputTypes =>
    Types.union([inputTypes.then.type, inputTypes.else.type]),
  resolver: ({condition, then, else: elseValue}) => {
    if (condition) {
      return then;
    } else {
      return elseValue;
    }
  },
  resolveOutputType: async (node, executableNode, client) => {
    const conditionNode = node.fromOp.inputs.condition;
    const thenNode = node.fromOp.inputs.then;
    const elseNode = node.fromOp.inputs.else;
    const condition = await client.query(conditionNode);
    let nodeType = node.type;
    if (condition) {
      nodeType = thenNode.type;
    } else {
      nodeType = elseNode.type;
    }
    return {
      ...node,
      type: nodeType,
    };
  },
});
